<template>
  <div class="app dashboard-layout" :class="{ collapse: isSideBarCollapse }">
    <AppNavigation class="is-nav-fixed" />
    <AppSideNavComponent :isCollapse="isSideBarCollapse" @onClickCollapse="onClickCollapse" />
    <div class="view" :class="{ collapse: isSideBarCollapse }">
      <router-view />
    </div>
  </div>
  <OpenWizardSelectionPopup
    v-if="isShowWizardGettingStartedPopup"
    @on-click-action="onClickConnectIntegrateAction"
    @close="onClickConnectIntegrateAction('close')"
  />
</template>
<script lang="ts" setup>
import { ref } from "vue"
import AppNavigation from "@/components/AppNavigation/AppNavigation.vue"
import AppSideNavComponent from "@/components/AppSideNav/AppSideNavComponent.vue"
import OpenWizardSelectionPopup from "@/components/OpenWizardPopup/OpenWizardSelectionPopup.vue"
import { storeToRefs } from "pinia"
import { useProviderStore } from "@/store/modules/provider/providerStore"

const { updateIsShowWizardGettingStartedPopup } = useProviderStore()

const isSideBarCollapse = ref<boolean>(false)

const onClickCollapse = (payload: boolean): void => {
  isSideBarCollapse.value = payload
}

const { isShowWizardGettingStartedPopup } = storeToRefs(useProviderStore())

const onClickConnectIntegrateAction = (actionType: string) => {
  if (actionType === "close") {
    updateIsShowWizardGettingStartedPopup(false)
  } else {
    // next
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/utilities/variables";
@import "@/styles/utilities/mixins";
.view {
  // Sticky footer
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: $t-sidebar-width;
  min-height: 100vh;
  transition: padding 0.2s ease-in-out;

  &.collapse {
    padding-left: $t-sidebar-width-collapse;
  }
}

.dashboard-layout {
  padding-top: $nav-bar-height;

  &:deep() {
    .app-navigation.is-nav-fixed {
      left: calc($t-sidebar-width - 1px);
      transition: left 0.2s ease-in-out;
    }
  }

  &.collapse {
    .app-navigation.is-nav-fixed {
      left: calc($t-sidebar-width-collapse - 1px);
    }
  }
}
</style>
